import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';

import { Row, Col, Menu, MenuItem, Submenu, Carousel, CarouselItem, Pagination, Dropdown, DropdownMenu, DropdownItem } from "element-ui";

Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Menu.name, Menu);
Vue.component(MenuItem.name, MenuItem);
Vue.component(Submenu.name, Submenu);
Vue.component(Carousel.name, Carousel);
Vue.component(CarouselItem.name, CarouselItem);
Vue.component(Pagination.name, Pagination);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(DropdownItem.name, DropdownItem);